// src/logic/analyzer.js

export const analyzeResult = (scores) => {
  const { E, S, I, W } = scores;

  // 1. 전설의 동물 판별 로직 (우선순위 순)
  
  // [레비아탄] 지성(I) 점수가 압도적이고 사회성(S)이 거의 없을 때
  if (I >= 10 && S <= 2) return "LEVIATHAN";

  // [봉황] 외향(E)과 본능(W)이 모두 폭발적일 때
  if (E >= 9 && W >= 9) return "PHOENIX";

  // [해태] 모든 점수가 아주 비슷해서 완벽한 균형을 이룰 때 (차이가 1 이하)
  const values = [E, S, I, W];
  const isBalanced = Math.max(...values) - Math.min(...values) <= 1;
  if (isBalanced) return "HAETAE";

  // [유니콘] 특정 본능(W)이 다른 모든 수치보다 압도적으로 높을 때
  if (W >= 12) return "UNICORN";


// 2. 일반 및 Mix 동물 판별 로직
  const sortedTags = Object.keys(scores).sort((a, b) => scores[b] - scores[a]);
  const main = sortedTags[0];
  const sub = sortedTags[1];

  // [중요] 1위와 2위의 점수 차이를 계산합니다.
  const diff = scores[main] - scores[sub];

  // 차이가 1점 이하로 매우 적다면 "복합 성향(Mix)"으로 간주합니다.
  if (diff <= 1) {
    return `${main}_Mix`; // 예: S와 다른 점수가 비슷하면 "S_Mix" 반환
  }

  // 차이가 크다면 일반적인 조합 반환
  return `${main}_${sub}`; 
};